export default {
  attach: function attach() {},
  detach: function detach() {}
};


// WEBPACK FOOTER //
// ./node_modules/react-focus-lock/node_modules/focus-lock/dist/es2015/tabHook.js